import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Clock, AlertTriangle, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function TrialBanner() {
  const [trial, setTrial] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/trial/status`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => { if (res.data.trial) setTrial(res.data); })
      .catch(() => {});
  }, [token]);

  if (!trial || dismissed) return null;

  const isGrace = trial.subscription_status === 'grace_period';
  const isExpired = trial.subscription_status === 'expired';

  if (isExpired) {
    return (
      <div className="bg-gradient-to-r from-red-500/20 to-red-600/10 border border-red-500/30 rounded-2xl p-4 flex items-center gap-3 mb-6" data-testid="trial-expired-banner">
        <AlertTriangle size={18} className="text-red-400 shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-red-300">Trial Expired</p>
          <p className="text-xs text-red-400/70">Your free trial has ended. Subscribe to reactivate your site.</p>
        </div>
      </div>
    );
  }

  if (isGrace) {
    return (
      <div className="bg-gradient-to-r from-amber-500/15 to-orange-500/10 border border-amber-500/30 rounded-2xl p-4 flex items-center gap-3 mb-6" data-testid="trial-grace-banner">
        <AlertTriangle size={18} className="text-amber-400 shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-amber-300">Grace Period — {trial.grace_remaining} day{trial.grace_remaining !== 1 ? 's' : ''} left</p>
          <p className="text-xs text-amber-400/70">{trial.message}</p>
        </div>
        <button onClick={() => setDismissed(true)} className="text-amber-400/50 hover:text-amber-300"><X size={14} /></button>
      </div>
    );
  }

  // Active trial
  return (
    <div className="bg-gradient-to-r from-[#8B5CF6]/10 to-[#3B82F6]/10 border border-[#8B5CF6]/20 rounded-2xl p-4 flex items-center gap-3 mb-6" data-testid="trial-active-banner">
      <Clock size={18} className="text-[#A78BFA] shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-semibold text-[#A78BFA]">Free Trial — {trial.days_remaining} day{trial.days_remaining !== 1 ? 's' : ''} remaining</p>
        <p className="text-xs text-slate-400">Explore all features. Subscribe anytime to keep your site active.</p>
      </div>
      <button onClick={() => setDismissed(true)} className="text-slate-500 hover:text-white"><X size={14} /></button>
    </div>
  );
}
